import { MIN_VIEW_COLUMN_WIDTH, PINNED_COLUMN } from '@constants'
import { RestrictionData, TimeLineDTOType } from '@types'

const getColumnRestrictions = (
  restrictions: RestrictionData,
  columnCode: string,
  defaultOrder: number
) => {
  const order = Number(
    restrictions.order?.find(rOrder => rOrder.fieldCode === columnCode)?.value ?? defaultOrder
  )

  const width = Number(
    restrictions.width?.find(rWidth => rWidth.fieldCode === columnCode)?.value ??
      MIN_VIEW_COLUMN_WIDTH
  )

  const pinnedColumn = restrictions.fix?.find(rFix => rFix.fieldCode === columnCode)
    ?.value as PINNED_COLUMN

  return { order, width, pinnedColumn }
}

export const enrichConfigColumnsWithRestrictions = ({
  config,
  objectXRestrictions,
  objectYRestrictions,
}: {
  config: TimeLineDTOType
  objectXRestrictions: RestrictionData
  objectYRestrictions: RestrictionData
}) => {
  return {
    ...config,
    objectY: {
      ...config.objectY,
      columns: config.objectY.columns
        .map((column, index) => ({
          ...column,
          ...getColumnRestrictions(objectYRestrictions, column.code, index),
        }))
        .sort((a, b) => a.order - b.order),
    },
    objectX: {
      ...config.objectX,
      columns: config.objectX.columns
        .map((column, index) => ({
          ...column,
          ...getColumnRestrictions(objectXRestrictions, column.code, index),
        }))
        .sort((a, b) => a.order - b.order),
    },
  }
}
